/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".nsc-welcome-message[_ngcontent-%COMP%]{font-family:Roboto,'Helvetica Neue',sans-serif!important}.nsc-welcome-message[_ngcontent-%COMP%]     strong{font-weight:700!important}"];
export { styles as styles };
